import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { GetCloudStorageByIdParams, GetCloudStorageParams, GetCloudStorageResponse } from "./types";

export const cloudStorageAPI = {
  getCloudStorage: async (
    params: GetCloudStorageParams
  ): Promise<GetCloudStorageResponse> => {
    const response = await axiosApi.get<GetCloudStorageResponse>(
      `cloudStorage/previews/${params.applicationId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getCloudStorageById: async (
    params: GetCloudStorageByIdParams
  ): Promise<any> => {
    const response = await axiosApi.get<any>(
      `cloudStorage/download/${params.fileId}`,
      {
        params,
        responseType: "blob",
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
}